export const normalizeRequestDashboardCounts = (counts) => {
  if (!counts || typeof counts !== "object") return {};

  if (counts.data && typeof counts.data === "object" && !counts.total) {
    return counts.data;
  }

  return counts;
};

export default normalizeRequestDashboardCounts;
